import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import { swal, typeChecker } from "../../../utils/methods";
import { _post } from "../../../utils/network";

import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb.component';
import FormField from "../../../components/Form/FormField/FormField.component";
import LoadingButton from '../../../components/LoadingButton/LoadingButton.component';

const ProductCategoriesCreate = ({ componentType='create' }) => {
	const { t } = useTranslation();
	const { id } = useParams();
    const navigate = useNavigate();
	const breadcrumbItems = [
		{ title: t('dashboard'), link: '/dashboard' },
		{ title: t('product_categories'), link: '/product-categories-list' },
		{ title: t(componentType) }
	];
	const confirmSwal = statements => {
		swal(() => statements(), {
			text: t('are_you_sure_to_do_this'),
			confirmButtonText: t('yes'),
			cancelButtonText: t('no')
		});
	};

	const [createButtonIsLoading, setCreateButtonIsLoading] = useState(false);
	const createProductCategory = async (event) => {
		event.preventDefault();
		if(createButtonIsLoading)
			return 0;
		let title = event.target.productCategoryTitle.value.trim();
		if(!typeChecker(title, 'title'))
			return toast.warn(t('title') + ' ' + t('must_have_at_least_3_characters'));
		let is_active = event.target.productCategoryIsActive.checked ? 1 : 0;
		let type = event.target.productCategoryType.value;
		let body = {
			productcategory_id: id,
			productcategory_name: title,
			is_active,
			category_type: type,
			productcategory_information: {}
		};
		confirmSwal(async () => {
			setCreateButtonIsLoading(true);
			let response = await _post('/productcategories/admin/' + componentType, body);
			setCreateButtonIsLoading(false);
			switch(response.code){
				case 200:
					toast.success(response[t('api_message')]);
					if(componentType === 'create')
						event.target.reset();
					break;
				default:
					toast.error(response[t('api_message')]);
			}
		});
	};

	const [deleteButtonIsLoading, setDeleteButtonIsLoading] = useState(false);
	const deleteProductCategory = async () => {
		if(deleteButtonIsLoading)
			return 0;
		let body = {
			productcategory_id: id
		};
		confirmSwal(async () => {
			setDeleteButtonIsLoading(true);
			let response = await _post('/productcategories/admin/delete', body);
			setDeleteButtonIsLoading(false);
			switch(response.code){
				case 200:
					navigate("/product-categories-list");
					break;
				default:
					toast.error(response[t('api_message')]);
			}
		});
	};

	const [productCategory, setProductCategory] = useState({});
	const getProductCategory = async () => {
		let body = {
			productcategory_id: id
		};
		let response = await _post('/productcategories/admin/getOne', body);
		switch(response.code){
			case 200:
				setProductCategory(response.data.productcategory);
				break;
			default:
				toast.error(response[t('api_message')]);
		}
	};
	
	const productCategoryTypesList = [
		{ key: `${t('score1_name')} ${t('and')} ${t('score2_name')}`, value: 1 },
		{ key: t('score2_name'), value: 2 }
	];

	useEffect(() => {
		if(componentType === 'edit')
			getProductCategory();
	}, []);

	return (
		<>
			<Breadcrumb items={breadcrumbItems} />
			<div className="card mb-3">
				<div className="card-header">
					<h5 className="mb-0">{t(componentType)} {t('product_category')}</h5>
				</div>
				<div className="card-body bg-light">
					<form onSubmit={createProductCategory}>
						<div className="row gx-2">
							<FormField fieldKey="productCategoryTitle" title={t('title')} value={productCategory?.productcategory_name} required rtl />
							<FormField type="toggle" fieldKey="productCategoryIsActive" title={t('active')} value={productCategory?.is_active} required />
							<FormField type="select" fieldKey="productCategoryType" title={t('type')} value={productCategory?.category_type} required selectItems={productCategoryTypesList} />
						</div>
						<div>
							{componentType === 'create' ?
								<LoadingButton className="btn btn-primary d-inline-block mt-3 me-2" type="submit" name="create" isLoading={createButtonIsLoading}>
									<i className="fa fa-save"></i> {t('create')}
								</LoadingButton>
							:
								<>
									<LoadingButton className="btn btn-primary d-inline-block mt-3 me-2" type="submit" name="edit" isLoading={createButtonIsLoading}>
										<i className="fa fa-save"></i> {t('update')}
									</LoadingButton>
									<LoadingButton className="btn btn-danger d-inline-block mt-3" onClick={deleteProductCategory} type="button" name="delete" isLoading={deleteButtonIsLoading}>
										<i className="fa fa-trash"></i> {t('delete')}
									</LoadingButton>
								</>
							}
						</div>
					</form>
				</div>
			</div>
		</>
	);
};

export default ProductCategoriesCreate;
